import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Farm/landscape stroke icon. Deliberately has NO <clipPath>: the previous
 * version used a fixed `id` referenced via `url(#...)`, which iOS Safari
 * resolves against the FIRST matching id in the DOM — with multiple
 * instances rendered the icon disappeared entirely. All strokes fit the
 * viewBox, so clipping was redundant anyway.
 */
const FarmIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 32 24" sx={{ fill: 'none', ...props.sx }}>
      <path
        d="M5.80469 21.3466C12.6252 14.0174 18.7124 11.0981 30.2997 13.1871"
        stroke="currentColor"
        strokeWidth="1.37185"
        strokeLinecap="round"
      />
      <path
        d="M11.2363 21.9096C14.4221 16.8342 22.6028 14.8716 28.8549 16.8358"
        stroke="currentColor"
        strokeWidth="1.37185"
        strokeLinecap="round"
      />
      <path
        d="M0.689453 11.1998C6.37147 10.6353 10.35 11.762 13.7599 14.6098"
        stroke="currentColor"
        strokeWidth="1.37185"
        strokeLinecap="round"
      />
      <path
        d="M17.1699 22.2005C18.3069 20.5094 21.7169 18.8169 25.1263 19.9446"
        stroke="currentColor"
        strokeWidth="1.37185"
        strokeLinecap="round"
      />
      <path
        d="M9.7832 8.97264L9.78325 4.84319C9.78325 4.48851 9.97729 4.16176 10.29 3.98975L16.0784 0.805567C16.4004 0.628451 16.7951 0.644463 17.1014 0.847066L22.5523 4.45229C22.826 4.63331 22.9903 4.93799 22.9903 5.26425V10.073"
        stroke="currentColor"
        strokeWidth="1.37185"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export default FarmIcon;
